import LogbookHandover from "../common/logbook-transfer";

export default function CompanyLogbookTransfer() {
  return <LogbookHandover />;
}
